import { themeTokens } from "Core/Theme";

import { makeStyles, mergeClasses, shorthands } from "@fluentui/react-components";

import { AppLeftBarItemState } from "./AppLeftBarItem.types";

const useStyles = makeStyles({
    root: {
        ...shorthands.margin("2px", "0px"),
        ...shorthands.padding("6px", "0px"),
        fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        minWidth: 0,
        ":hover": {
            cursor: "pointer"
        },
        width: "64px",
        textDecorationLine: "none"
    },
    leftBarIcon: {
        height: "100%",
        ...shorthands.margin("0")
    },
    leftBarTitle: {
        fontSize: themeTokens.fontSizeBase100,
        fontWeight: themeTokens.fontWeightSemibold,
        textAlign: "center",
        maxWidth: "60px",
        lineHeight: "12px",
        ...shorthands.overflow("hidden")
    },
    menuPopUp: {
        ...shorthands.padding(0)
    },
    selectedBar: {
        position: "absolute",
        left: "2px",
        borderLeftWidth: "2px",
        borderLeftStyle: "solid",
        borderLeftColor: themeTokens.selectedBarYellowForeground,
        height: "70%",
        zIndex: 10
    }
});

const useHighlightColorStyles = makeStyles({
    root: {
        backgroundColor: themeTokens.colorNeutralForegroundInvertedHover
    },
    iconColor: {
        color: themeTokens.colorPaletteMarigoldForeground3
    },
    leftBarTitle: {
        color: themeTokens.colorNeutralForeground3
    }
});

const useNormalColorStyles = makeStyles({
    root: {
        backgroundColor: themeTokens.colorNeutralBackground3
    },
    iconColor: {
        color: themeTokens.colorNeutralForeground3
    },
    leftBarTitle: {
        color: themeTokens.colorNeutralForeground3
    }
});

export const useAppLeftBarItemStyles = (state: AppLeftBarItemState) => {
    const { isMouseOver, selected } = state;
    const styles = useStyles();
    const highlightStyles = useHighlightColorStyles();
    const normalColorStyles = useNormalColorStyles();

    styles.root = isMouseOver ? mergeClasses(styles.root, highlightStyles.root) : mergeClasses(styles.root, normalColorStyles.root);

    styles.leftBarIcon =
        isMouseOver || selected ? mergeClasses(styles.leftBarIcon, highlightStyles.iconColor) : mergeClasses(styles.leftBarIcon, normalColorStyles.iconColor);

    styles.leftBarTitle =
        isMouseOver || selected
            ? mergeClasses(styles.leftBarTitle, highlightStyles.leftBarTitle)
            : mergeClasses(styles.leftBarTitle, normalColorStyles.leftBarTitle);
    return styles;
};
